//Generated File 
export const ApprovalCase = `ApprovalCase`;
export const CostInTrans = `CostInTrans`;
export const CostOutTrans = `CostOutTrans`;
export const FifoCostTrans = `FifoCostTrans`;
export const LedgerTrans = `LedgerTrans`;
export const QtySemiTrans = `QtySemiTrans`;
export const QtyTrans = `QtyTrans`;
export const ReservationTrans = `ReservationTrans`;
